export default __webpack_public_path__ + "static/media/wagmi-3x.5589535a.jpeg";